// extracted by mini-css-extract-plugin
module.exports = {"profile-collapse-section":"profile-collapse-section___2bhob","section-data":"section-data___qbmM9","nickname-icon":"nickname-icon___3YSYe"};